








































































































































import { Component, Vue } from "vue-property-decorator";
import requestNew from "@/api/newchongqing/index";
import AppPrompt from "@/components/AppPrompt.vue";
import requestwanzhou from "@/api/wanzhou/index";
import { findNameByWechatAppid, historyProjectHost } from "@/common/Utils";
import { Base64 } from "js-base64";
import nopage from "@/components/newchongqing404.vue";
import {
  Toast,
  ImagePreview,
  List as vanList,
  Dialog,
  Loading as vanLoading
} from "vant";
import native from "@/common/Native";
import { wxChatShare } from "@/common/wechat";
import { ICommentItem } from "@/api/types";
import CommentItem from "@/components/CommentItem.vue";

import {
  IShareConfig,
  IShareConfigItem,
  IComment,
  IHot,
  ICommonItem
} from "@/api/types";

import Base from "@/template/public/Base.vue";
import { getData, time } from "@/common/dataCollect";
const appDownloadUrlPre = "http://www.newchongqing.com/install/index.html?id=";
const schemeUrl = "http://mncq.cqliving.com";
let timer: any = 0;

@Component({
  components: {
    CommentItem,
    vanList,
    vanLoading,
    nopage,
    AppPrompt
  }
})
export default class App extends Base {
  requestwanzhou: any = new requestwanzhou();
  private appId: string = "";
  isInApp: boolean = false;
  isRequestLoaded: boolean = false;
  isPlayAudio: boolean = false;
  isNoPlay: boolean = true;
  isFoucs: boolean = false;
  private isLoading: boolean = false;
  private loading: boolean = false;
  private finished: boolean = false;
  private lastCreateTime: string = "";
  private lastReplyId?: number;
  private article: any = {
    shiJiaPeople: {}
  };
  private userInfo: any = {
    appId: "",
    sessionId: "",
    token: ""
  };
  private businessDetail: any = {
    isPraised: "",
    viewCount: "",
    praiseCount: "",
    replyCount: ""
  };
  private commentList: ICommentItem[] = [];
  // 埋点
  startTime: string = "";
  endTime: string = "";
  dataSource = true;
  wxAppId = "";
  created() {
    this.startTime = time();
  }
  mounted() {
    this.appId = (this.$route.query.appId as string) || "";
    this.infoClassifyId = this.$route.query.id
      ? (this.$route.query.id as string)
      : (this.$route.query.cid as string) || "";
    this.isInApp = native.isOpenInApp();
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
    if (this.isInApp) {
      native
        .getUserInfo()
        .then(res => {
          this.userInfo = res;
          this.getDetail();
        })
        .catch(() => {
          this.getDetail();
        });
    } else {
      this.getDetail();
    }
    // clearInterval(timer);
    // timer = setInterval(() => {
    //   if (this.isInApp) {
    //     native
    //       .getUserInfo()
    //       .then(res => {
    //         this.userInfo = res;
    //         this.getDetailPurely();
    //       })
    //       .catch(() => {
    //         this.getDetailPurely();
    //       });
    //   } else {
    //     this.getDetailPurely();
    //   }
    // }, 2000);

    setTimeout(() => {
      let clientHeight = getViewPortHeight() as number;
      let shareBottom = this.$refs.shareBottom as HTMLElement;
      (this.$refs.articleDetail as HTMLElement).style.minHeight =
        clientHeight -
        (this.$refs.articleDetail as HTMLElement).offsetTop -
        shareBottom.offsetHeight +
        "px";
      function getViewPortHeight() {
        return (
          document.documentElement.clientHeight || document.body.clientHeight
        );
      }
    }, 100);
  }
  beforeDestroy() {
    clearInterval(timer);
  }
  get isSpecialColumn() {
    let column = [11202, 11203, 11204];
    if (column.includes(this.article.columnsId)) {
      return true;
    }
    return false;
  }
  /**评论列表 */
  getCommentList(isClear = true) {
    if (isClear) {
      // 如果要清除所有，重新加载，需要重置到第一页
      this.lastCreateTime = "";
      this.lastReplyId = undefined;
    }
    this.requestwanzhou
      .getCommentListPage(
        this.appId,
        this.userInfo.sessionId,
        this.article.id,
        "1",
        this.lastCreateTime,
        this.lastReplyId,
        this.userInfo.token
      )
      .then((response: IComment) => {
        if (response.code >= 0) {
          if (isClear) {
            this.commentList = [];
          }
          if (response.data.dataList.length === 0) {
            this.finished = true;
          } else {
            this.commentList = this.commentList.concat(response.data.dataList);
            this.lastCreateTime = response.data.dataList.lastChild
              .createTime as string;
            this.lastReplyId = response.data.dataList.lastChild.replyId;
          }
          this.isLoading = false;
        }
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }
  onLoad() {
    if (this.infoClassifyId && this.isRequestLoaded && !this.finished) {
      this.getCommentList(false);
    }
  }
  /**业务详情 */
  getBussinessDetail() {
    this.requestwanzhou
      .getBussinessDetail(
        this.appId,
        this.userInfo.sessionId,
        // this.newsInfo.informationId,
        this.infoClassifyId as string,
        "1",
        this.userInfo.token
      )
      .then((response: any) => {
        if (response.code >= 0) {
          this.businessDetail = response.data;
          wxChatShare(
            response.data.detailTitle,
            response.data.shareDescription,
            window.location.href,
            response.data.shareImgUrl
          );
        }
      });
  }
  // 存粹的调用详情
  getDetailPurely() {
    requestNew
      .infoDetailNewSijia({
        token: this.userInfo.token,
        infoClassifyId: this.infoClassifyId as string
      })
      .then(res => {
        if (res.code >= 0) {
          this.article = res.data;
          if (!this.article.peshiJiaPeople) {
            this.article.peshiJiaPeople = {};
          }
        }
      });
  }
  getDetail() {
    // this.newsDetail
    // console.log({
    //     token: this.userInfo.token,
    //     infoClassifyId: this.infoClassifyId as string
    //   })
    requestNew
      .infoDetailNewSijia({
        token: this.userInfo.token,
        infoClassifyId: this.infoClassifyId as string
      })
      .then(res => {
        if (res.code >= 0) {
          this.article = res.data;
          document.title = this.article.title;

          requestNew
            .getInfoDetailshiJiaPeople({
              token: this.userInfo.token,
              columnsId: this.article.columnsId as string
            })
            .then(res => {
              this.article.shiJiaPeople = res.data;
            });
          if (!this.article.peshiJiaPeople) {
            this.article.peshiJiaPeople = {};
          }
          this.getBussinessDetail();
          // this.getShareInfo(this.article.appId);
          this.getBaseappInfoConfigList(this.article.appId);
          this.appShareConfig();
          this.$nextTick(() => {
            this.getCommentList(true);
            setTimeout(() => {
              this.imageHandle();
              this.lazyHandle();
            }, 200);
          });
          this.$nextTick(() => {
            // 埋点
            this.endTime = time();
            if (this.dataSource) {
              getData(this.startTime, this.endTime, res.data);
              this.dataSource = false;
            }
          });
        }
      })
      .finally(() => {
        this.isRequestLoaded = true;
      });
  }
  appShareConfig() {
    if (native.isOpenInApp()) {
      try {
        ZWY_CLOUD.shareConfig({
          id: this.article.infoClassifyId,
          shareTitle: this.article.title,
          shareDescription: this.article.synopsis,
          sourceType: this.article.sourceType,
          shareImgUrl: this.article.shareImgUrl,
          shareUrl: window.location.href,
          shareUrlQQ: window.location.href,
          shareUrlQzone: window.location.href,
          shareUrlWx: window.location.href,
          shareUrlWxMoments: window.location.href,
          shareUrlWeibo: window.location.href
        });
      } catch (error) {
        console.log(error);
      }

      //     id: 主键id
      //  ** shareTitle: 分享标题 //必传参数
      //  ** shareDescription:分享内容 //必传参数
      //  ** sourceType: 分享内容sourceType
      //  ** shareImgUrl: 分享图标 //必传参数
      //  ** shareUrl: 分享地址 //必传参数
      //  ** shareUrlQQ: 分享地址  QQ
      //  ** shareUrlQzone: 分享地址  QQ空间
      //  ** shareUrlWx: 分享地址  微信好友
      //  ** shareUrlWxMoments: 分享地址  微信朋友圈
      //  ** shareUrlWeibo: 分享地址  微博
    }
  }
  //懒加载处理
  lazyHandle() {
    //图片视频的懒加载
    class LazyImage {
      private imageElements: Array<Element> = [];
      private _throttleFn: any;
      constructor() {
        this.imageElements = Array.prototype.slice.call(
          document.querySelectorAll(".article-detail img[data-original]")
        );
        // alert(this.imageElements)
        this.init();
      }
      init() {
        this.inViewShow();
        this._throttleFn = this.throttle(this.inViewShow);
        addEvent(
          document.querySelector("#app"),
          "scroll",
          this._throttleFn.bind(this),
          false
        );
        // }
      }
      inViewShow() {
        let len = this.imageElements.length;
        // console.log("scroll");
        for (let i = 0; i < len; i++) {
          let imageElement = this.imageElements[i];
          let rect = imageElement.getBoundingClientRect();
          // 出现在视野的时候加载图片
          if (rect.top < document.documentElement.clientHeight) {
            let dataSrc = imageElement.getAttribute("data-original") as string;
            let dataSrc2 = imageElement.getAttribute("src") as string;
            dataSrc && imageElement.setAttribute("src", dataSrc);
            imageElement.removeAttribute("data-original");
            imageElement.setAttribute("data-original2", dataSrc);
            // 移除掉已经显示的
            this.imageElements.splice(i, 1);
            len--;
            i--;
            if (this.imageElements.length === 0) {
              // 如果全部都加载完 则去掉滚动事件监听
              // document.removeEventListener('scroll', this._throttleFn)
              removeEvent(document, "scroll", this._throttleFn, false);
            }
          }

          imageElement.addEventListener("error", function(e: any) {
            let datasrc = imageElement.getAttribute("data-original2") as string;
            imageElement.setAttribute("src", datasrc);
          });
        }
      }
      throttle(fn: any, delay: number = 15, mustRun: number = 30) {
        let t_start: number | null = null;
        let timer: any = null;
        let context = this;
        return function() {
          let t_current = +new Date();
          let args = Array.prototype.slice.call(arguments);
          clearTimeout(timer);
          if (!t_start) {
            t_start = t_current;
          }
          if (t_current - t_start > mustRun) {
            fn.apply(context, args);
            t_start = t_current;
          } else {
            timer = setTimeout(function() {
              fn.apply(context, args);
            }, delay);
          }
        };
      }
    }
    new LazyImage();
    //兼容IE浏览器
    // 事件绑定
    function addEvent(element: any, eType: any, handle: any, bol: any) {
      if (element.addEventListener) {
        //如果支持addEventListener
        element.addEventListener(eType, handle, bol);
      } else if (element.attachEvent) {
        //如果支持attachEvent
        element.attachEvent("on" + eType, handle);
      } else {
        //否则使用兼容的onclick绑定
        element["on" + eType] = handle;
      }
    }
    // 事件解绑
    function removeEvent(element: any, eType: any, handle: any, bol: any) {
      if (element.addEventListener) {
        element.removeEventListener(eType, handle, bol);
      } else if (element.attachEvent) {
        element.detachEvent("on" + eType, handle);
      } else {
        element["on" + eType] = null;
      }
    }
  }
  // openApp() {
  //   if (this.isInApp) {
  //     return;
  //   } else {
  //     let appDownloadUrl = appDownloadUrlPre + this.appId
  //     if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
  //       var awakenAppParams =
  //         "url=" +
  //         location.href +
  //         "&&&title=" +
  //         Base64.encode(this.article.title) +
  //         "&&&synopsis=" +
  //         Base64.encode(this.article.synopsis);
  //       location.href =
  //         schemeUrl +
  //         "/info/install/" +
  //         this.appId +
  //         ".html?" +
  //         awakenAppParams;
  //       setTimeout(function() {
  //         location.href = appDownloadUrl;
  //       }, 1000);
  //     } else if (/(Android)/i.test(navigator.userAgent)) {
  //       let awakenAppParams: any = {
  //         url: location.href,
  //         title: Base64.encode(this.article.title),
  //         synopsis: Base64.encode(this.article.synopsis),
  //       };
  //       let ifr = document.createElement("iframe");
  //       ifr.src =
  //         schemeUrl.replace("http://", "") +
  //         "://" +
  //         "?params=" +
  //         JSON.stringify(awakenAppParams);
  //       ifr.style.display = "none";
  //       document.body.appendChild(ifr);
  //       window.setTimeout(function() {
  //         document.body.removeChild(ifr);
  //         location.href = appDownloadUrl;
  //       }, 1000);
  //     } else {
  //       location.href = appDownloadUrl;
  //     }
  //   }
  // }
  toPraisePay() {
    let ua = navigator.userAgent.toLowerCase();
    let isWeixin = ua.indexOf("micromessenger") != -1;
    // console.log(historyProjectHost() +
    //     "#/pay?appId=" +
    //     this.appId +
    //     "&editorId=" +
    //     this.article.shiJiaPeople.id +
    //     "&newsId=" +
    //     this.infoClassifyId)
    //   return
    if (this.isInApp) {
      native.goToken().then((res: any) => {
        this.userInfo = res;
        if (!this.article.shiJiaPeople) {
          return Toast("未获取到作者信息");
        }
        // 调到支付
        let url =
          historyProjectHost() +
          "#/pay?appId=" +
          this.appId +
          "&editorId=" +
          this.article.shiJiaPeople.id +
          "&newsId=" +
          this.infoClassifyId;
        this.redirectUrl(url, "赞赏");
      });
    } else if (isWeixin) {
      // 支付审核现在不通 先跳app
      this.newopenapp();
      return;
      // 微信 调到支付
      // if (!this.article.shiJiaPeople) {
      //   return Toast("未获取到作者信息");
      // }
      // let url =
      //   historyProjectHost() +
      //   "#/pay?appId=" +
      //   this.appId +
      //   "&editorId=" +
      //   this.article.shiJiaPeople.id +
      //   "&newsId=" +
      //   this.infoClassifyId;
      // window.location.href = url;
    } else {
      this.newopenapp();
    }
  }
  // 播放语音播报
  playVoice() {
    const ele = this.$refs.audioEle as HTMLAudioElement;
    this.isNoPlay = false;
    if (!this.isPlayAudio) {
      ele && ele.play();
      this.isPlayAudio = true;
    } else {
      ele && ele.pause();
      this.isPlayAudio = false;
    }
  }
  // 处理图片预览功能
  imageHandle() {
    let _this = this;
    const elements = Array.prototype.slice.call(
      document.querySelectorAll(".article-detail img"),
      0
    );
    let srcArr: Array<string> = [];
    elements.forEach(item => {
      if (item.getAttribute("data-original")) {
        srcArr.push(item.getAttribute("data-original"));
      } else {
        srcArr.push(item.getAttribute("src"));
      }
    });
    console.log(srcArr);
    elements.forEach((v, i) => {
      (function(i) {
        v.addEventListener(
          "click",
          function(e: any) {
            console.log(i);
            ImagePreview({
              images: srcArr,
              startPosition: i,
              closeable: true
            });
          },
          false
        );
      })(i);
    });
  }
  follow(status: string) {
    if (this.isInApp) {
      native
        .goToken()
        .then((res: any) => {
          this.userInfo = res;
          // alert(JSON.stringify(res))
          this.followRequest(status);
        })
        .catch(() => {
          Toast("请先登录");
        });
    } else {
      this.newopenapp();
    }
  }
  followRequest(status: string) {
    requestNew
      .follow({
        appId: this.appId,
        infoId: this.article.shiJiaPeople.id,
        token: this.userInfo.token,
        status: status,
        type: "1"
      })
      .then(res => {
        if (res.code >= 0) {
          ZWY_CLOUD.historianFollowChange();
          this.getDetail();
        } else {
          Toast(res.message);
        }
      });
  }
  toEditorDetail() {
    if (this.isInApp) {
      if (!this.article.shiJiaPeople.id) {
        return Toast("暂无作者信息");
      }
      let url =
        historyProjectHost() +
        "#/person?appId=" +
        this.appId +
        "&editorId=" +
        this.article.shiJiaPeople.id;
      this.redirectUrl(url, Base64.encode("史家作者详情"));
    } else {
      this.newopenapp();
    }
  }
  doPraise1() {
    this.newopenapp();
  }
  toCommentDetail() {
    this.newopenapp();
  }
  redirectUrl(url: string, title: string) {
    native.openWebBrowser({
      id: "",
      sourceId: "",
      detailViewType: "9",
      sourceType: "12",
      commentType: "1",
      contextType: "",
      isShowTop: "0",
      isShowBottom: "0",
      isShowMore: "1",
      url: url,
      shareUrl: "",
      title, //base 64
      synopsis: "", //base 64
      shareImgUrl: ""
      // shareTitle: item.shareTitle // base 64
    });
  }
  //图片预览
  toImagePreview(item: any) {
    if (native.isOpenInApp()) {
      native.viewImageContent({
        array: [
          {
            imgUrl: item.imageUrl,
            desc: ""
          }
        ],
        index: 0
      });
    } else {
      Dialog.alert({
        message: "请前往下载" + this.shareInfo.appName + "客户端！",
        closeOnClickOverlay: true
      }).then(() => {
        // on close
        // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
        // window.location.href = this.downloadUrl;
        this.newopenapp();
      });
    }
  }
  newopenapp() {
    (this.$refs.newopenapp as any).openApp();
  }
}
